const content = {
  component: "PageTypeA",
  cssClass: "page-four",
  meta: {
    title: "Wine.com.br: delivering moments of pleasure and happiness",
    description:
      "Tony’s Chocolonely is fighting slavery in the chocolate industry. Thanks to cloud, they’ve been able to scale quickly, bringing their ethical, “slave-free chocolate”",
    og: {
      type: "website",
      title: "Cloud enables ethical business—read how",
      description: `Tony’s Chocolonely’s ethical, “slave-free chocolate” experienced great success—but big growth came with big challenges. By using cloud, the business was able to stop wasting time maintaining spreadsheets, and get back to doing what they did best—making delicious, fair-trade chocolate. `,
      image: require("../../assets/images/social/moments-of-pleasure-1200x630.jpg")
    },
    twitter: {
      card: "summary",
      title: "Read how cloud helped a fair-trade chocolate business flourish",
      description: `By using cloud, fair-trade chocolate producer Tony’s Chocolonely has been able to scale their operations, enabling them to bring delicious, ethical products to chocoholics all across the world. `,
      site: "@Oracle",
      creator: "@Oracle",
      image: require("../../assets/images/social/moments-of-pleasure-300x300.jpg")
    }
  },
  title:
    "<span>Wine.com.br: Delivering Moments </span><span>of Pleasure and Happiness</span>",
  heroImage: {
    preload: require("../../assets/images/bgs/moments-of-pleasure-pre.jpg"),
    loaded: require("../../assets/images/bgs/moments-of-pleasure.jpg"),
    mobile: require("../../assets/images/bgs/moments-of-pleasure-mobile.jpg")
  },
  // * the heroImageOptions are currently only required and supported when using the PageTypeA component
  heroImageOptions: {
    default: {
      customPosition: [false]
    },
    mobile: {
      customPosition: [false]
    },
    limtedHeight: {
      customPosition: [false]
    }
  },
  sections: [
    {
      component: "SectionCopy",
      content: {
        copy: `
          Of all the things Brazil is known for, becoming one of the fastest-growing wine markets is not among them. But that’s about to change. Wine e-commerce merchant Wine.com.br has taken the unusual step of trying to develop a wine-loving culture in a country where one barely existed before.
        `,
        type: "intro"
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: null
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>Its timing coincides with a deepening appreciation for the product. According to research from Euromonitor International, Brazil’s thirst for imported wine will grow making it the fastest-growing wine market in the world.</p>
          <p>The Brazilian startup is using cloud technology and advanced data analytics to identify potential customers, while keeping existing customers in the fold in part by using highly personalised marketing campaigns driven by an analysis of their past behaviours.</p>
          <p>To build its customer base, the company launched a subscription-based wine club, ClubeW to encourage members to try new experiences, share their feedback, and, hopefully, come back for more wine.  The company claims it took four years to acquire 40,000 members, mostly experienced wine drinkers.</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: require("../../assets/images/svgs/wine.svg")
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>The next step was to try to convert some of the 77.6% of Brazilian adults who don’t drink wine, starting with upwardly mobile millennials. Under CMO Richard Flores, Wine.com.br sent personalized wine recommendations to potential customers.</p>
          <p>The engine of Wine.com.br’s automated e-mail marketing campaigns is the Oracle Responsys Marketing Cloud Platform, which allows the company to develop personalized marketing content according to the level of each customer’s wine-drinking experience. This capability becomes particularly important as customers evolve from entry-level wine drinkers to enthusiasts and ultimately to connoisseurs.</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionQuote",
      content: {
        quote: `Moving some of our marketing capabilities to the cloud enabled us to react and scale faster. This has been a game changer, since our volumes keep doubling every year.`,
        author: `Richard Flores`,
        position: `CMO, Wine.com.br`,
        type: "quote",
        backgroundImage: require("../../assets/images/bgs/MomentsOfPleasure_Wine_bg.jpg")
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>Responsys, integrated with the company’s data warehouse and proprietary recommendation system, lets the company test and retest customer purchase data and consumption feedback, as well as conduct cross-profile correlation analysis to produce future recommendations. The system then suggests the best products or campaigns for each customer.</p>
          <p>The result helps Wine.com.br avoid misplaced marketing messages and instead cultivate meaningful interactions and relationships with its customers. Although the company mostly has two sets of customers—experienced wine drinkers and new entrants—it didn’t want to treat customers as profiles, but as unique individuals.</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionImage",
      content: {
        image: require("../../assets/images/content/MomentsOfPleasure-InlineImage.jpg"),
        alt: "",
        type: "image"
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>Since Wine.com.br entered the market in 2008, it has grown from R$9 million (US$2.8 million) in its first year to an estimated R$300 million (US$95.5 million) in 2015. In the process, it has become the third-largest wine e-commerce company in the world and the number one wine e-tailer in Latin America.</p>
          <p>Wine.com.br has also started selling craft beer (WBeer.com.br), and last year it acquired a coffee capsule company, Mocoffee. Says CEO Rogerio Salume: “We have the privilege to work with what we believe and love: delivering moments of pleasure and happiness to each one of our customers.”</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionCallToAction",
      content: {
        title: `Transform your business with Oracle`,
        ctas: [
          {
            image: require("../../assets/images/svgs/report.svg"),
            copy: "Decision makers and technology report",
            url:
              "https://www.oracle.com/uk/applications/customer-experience/uncovering-hype-around-innovative-technology.html?source=:ow:o:cs:mt:RC_EMMK181024P00070C0001:YTTFY19_CX_AW_HI_CM_UK_C33_Q33_RT&intcmp=:ow:o:cs:mt:RC_EMMK181024P00070C0001:YTTFY19_CX_AW_HI_CM_UK_C33_Q33_RT",
            buttonCopy: "Read report"
          },
          {
            image: require("../../assets/images/svgs/servers.svg"),
            copy: "Try out Oracle Cloud Solutions",
            url:
              "https://go.oracle.com/LP=73495?qt=saas_cx_mkt&src1=:ow:o:cs:mt:RC_EMMK181024P00070C0001:YTTFY19_CX_CT_QT_CM_UK_C38_Q34&intcmp=WWMK161025P00072:ow:o:cs:mt:RC_EMMK181024P00070C0001:YTTFY19_CX_CT_QT_CM_UK_C38_Q34",
            buttonCopy: "Try now"
          }
        ],
        type: "cta"
      }
    }
  ]
};

export default content;
